import { Component } from '@angular/core';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import { PrivateBookingModalComponent } from '../private-booking-modal/private-booking-modal.component';
import {
  BookingsDisplayMode,
  BookingsScope,
} from '../../../core/store/bookings/bookings.state';
import { parseISO } from 'date-fns';
import { ModalService } from '../../../core/services/modal.service';
import { Store } from '@ngrx/store';
import { bookingsActions } from 'angular/app/core/store/bookings';
import { selectFocusedBooking } from '../../../core/store/reducers';

@Component({
  selector: 'app-personal-bookings-modal',
  template: `
    <app-modal [modalInstance]="modalInstance">
      <div class="mb-6 flex justify-end md:mb-10">
        <app-button icon="plus" (click)="createPrivateBooking()"
          >Ajouter</app-button
        >
      </div>
      <app-bookings-list [scope]="BookingsScope.Personal"></app-bookings-list>
    </app-modal>
  `,
  standalone: false,
})
export class PersonalBookingsModalComponent extends ModalBaseComponent {
  BookingsScope = BookingsScope;
  booking = this.store.selectSignal(selectFocusedBooking);

  constructor(
    private modalService: ModalService,
    private store: Store,
  ) {
    super();
  }

  createPrivateBooking() {
    const instance = this.modalService.open(PrivateBookingModalComponent, {
      title: 'Ajouter une réservation interne',
      size: 'screen',
    });
    (
      instance.componentRef.instance as PrivateBookingModalComponent
    ).bookingSaved.subscribe(() => {
      this.store.dispatch(
        bookingsActions.setDisplayMode({
          displayMode: BookingsDisplayMode.Week,
          scope: BookingsScope.Personal,
        }),
      );
      this.store.dispatch(
        bookingsActions.setCalendarDate({
          date: parseISO(this.booking().start),
          scope: BookingsScope.Personal,
        }),
      );
    });
  }
}
